import {
    MISSIONS_FAILURE,
    MISSIONS_PENDING,
    // GET_MISSIONS_FAILURE,
    // GET_MISSIONS_PENDING,
    GET_MISSIONS_SUCCESS,
    // GET_MISSION_FAILURE,
    // GET_MISSION_PENDING,
    GET_MISSION_SUCCESS,
    GET_CURRENT_MISSION_SUCCESS,
    UPDATE_MISSION_SUCCESS,
    MISSION_CANCEL_SUCCESS,
    EXECUTE_CURRENT_MISSION_SUCCESS,
    CLEAR_DRONE_COMMANDS_SUCCESS,
} from 'store/actions-type/missions';

export const missionsPending = () => ({
    type: MISSIONS_PENDING,
});

export const getMissionsSuccess = missions => ({
    type: GET_MISSIONS_SUCCESS,
    payload: { missions },
});

export const missionsFailure = error => ({
    type: MISSIONS_FAILURE,
    payload: { error },
});

// export const getMissionPending = () => ({ type: GET_MISSION_PENDING });

export const getMissionSuccess = mission => ({
    type: GET_MISSION_SUCCESS,
    payload: { mission },
});

export const getCurrentMissionSuccess = mission => ({
    type: GET_CURRENT_MISSION_SUCCESS,
    payload: mission,
});

// export const getMissionFailure = error => ({
//     type: GET_MISSION_FAILURE,
//     payload: { error },
// });

export const missionAssignSuccess = mission => ({
    type: GET_CURRENT_MISSION_SUCCESS,
    payload: mission,
});

export const missionCancelSuccess = mission => ({
    type: MISSION_CANCEL_SUCCESS,
    payload: mission,
});

export const executeCurrentMissionSuccess = mission => ({
    type: EXECUTE_CURRENT_MISSION_SUCCESS,
    payload: mission,
});

export const clearDroneCommandsSuccess = mission => ({
    type: CLEAR_DRONE_COMMANDS_SUCCESS,
    payload: mission,
});

export const updateMissionSuccess = mission => ({
    type: UPDATE_MISSION_SUCCESS,
    payload: { mission },
});
